import { types as api } from '@mesa-labs/mesa-api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AdjustmentGroupsState = {
  sortField?: string;
  sortDirection: api.SortDirection;
};

export const initialState: AdjustmentGroupsState = {
  sortField: undefined,
  sortDirection: api.SortDirection.ASCENDING,
};

const adjustmentGroupsSlice = createSlice({
  name: 'adjustmentGroups',
  initialState,
  reducers: {
    updateSortField(state: AdjustmentGroupsState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: AdjustmentGroupsState, action: PayloadAction<api.SortDirection>) {
      state.sortDirection = action.payload;
    },
  },
});

export const {
  updateSortField,
  updateSortDirection,
} = adjustmentGroupsSlice.actions;
export default adjustmentGroupsSlice.reducer;
